import { useEffect } from 'react';
import { useAuth } from '../../../app/providers/AuthContext';

/**
 * Post-logout success page.
 * Clears server session on direct navigation and provides re-login option.
 */
function LogoutSuccess() {
  const { signIn } = useAuth();

  // Clear server session when user navigates directly to /logout URL
  useEffect(() => {
    const apiUrl = import.meta.env.VITE_API_URL || '/api';
    fetch(`${apiUrl}/auth/logout`, {
      method: 'GET',
      credentials: 'include',
    }).catch(() => {
      // Ignore errors - logout page should always display
    });
  }, []);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      backgroundColor: '#f9fafb'
    }}>
      <div style={{
        textAlign: 'center',
        padding: '48px',
        backgroundColor: 'white',
        borderRadius: '16px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        maxWidth: '400px'
      }}>
        <div style={{ fontSize: '48px', marginBottom: '16px' }}>
          <span role="img" aria-label="wave">👋</span>
        </div>
        <h2 style={{ fontSize: '24px', fontWeight: '600', color: '#1f2937', marginBottom: '16px' }}>
          已退出登录
        </h2>
        <p style={{ fontSize: '16px', color: '#6b7280', marginBottom: '24px' }}>
          您已成功退出登录
        </p>
        <button
          onClick={signIn}
          style={{
            width: '100%',
            padding: '12px 24px',
            fontSize: '16px',
            fontWeight: '600',
            color: 'white',
            backgroundColor: '#3b82f6',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
          }}
        >
          重新登录
        </button>
      </div>
    </div>
  );
}

export default LogoutSuccess;
